import strings from 'common/strings';
import {
  defaultVelocityEngageFolioFolderDocument,
  VelocityEngageFolioFolderDocument,
} from 'models';
import { AutoScroller, MuuriComponent } from 'muuri-react';
import React, { RefObject, useState } from 'react';
import EngageMediaItem from '../EngageMediaItem';
import './MediaContainer.scss';

interface MediaContainerProps {
  title: string;
  icon?: React.ReactElement | null;
  media: VelocityEngageFolioFolderDocument[];
  scrollRef: RefObject<HTMLDivElement>;
  folderId: string;
  vehicleId: string;
  onStar: (document: VelocityEngageFolioFolderDocument) => void;
  onPublish: (document: VelocityEngageFolioFolderDocument) => void;
  onDelete: (document: VelocityEngageFolioFolderDocument) => void;
  onEdit: (document: VelocityEngageFolioFolderDocument, title: string) => void;
  onReorder: (folderId: string, reorderObject: Record<string, number>) => void;
}

const MediaContainer: React.FC<MediaContainerProps> = ({
  title,
  icon,
  media,
  scrollRef,
  onStar,
  onPublish,
  onDelete,
  onEdit,
  onReorder,
  folderId,
  vehicleId,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const children = media.map((item: VelocityEngageFolioFolderDocument) => {
    let mediaItem =
      item?.type?.name === 'WINDOW_STICKER'
        ? {
            ...item,
            url: item.url + '?source=Velocity Recon',
          }
        : item;

    return (
      <EngageMediaItem
        key={mediaItem.id}
        media={mediaItem}
        isOpenNewTab={
          mediaItem?.type?.name === 'WINDOW_STICKER' &&
          mediaItem?.url?.trim().length > 0 &&
          mediaItem.url.includes('https://windowsticker')
        }
        inFeaturedMediaContainer={title === strings.FEATURED}
        onStar={onStar}
        onPublish={onPublish}
        onDelete={onDelete}
        onEdit={onEdit}
        isDragging={isDragging}
        folderId={folderId}
        vehicleId={vehicleId}
      />
    );
  });

  if (title !== strings.FEATURED) {
    children.push(
      <EngageMediaItem
        key="add-media-item"
        media={defaultVelocityEngageFolioFolderDocument(strings.ADD_MEDIA)}
        inFeaturedMediaContainer={title === strings.FEATURED}
        onStar={onStar}
        onPublish={onPublish}
        onDelete={onDelete}
        onEdit={onEdit}
        isDragging={isDragging}
        folderId={folderId}
        vehicleId={vehicleId}
        isOpenNewTab={false}
      />
    );
  }

  return (
    <div className="MediaContainer" ref={scrollRef}>
      <div className="MediaContainer-title">
        {icon && icon}
        {title}
      </div>
      {media.length > 0 ? (
        <MuuriComponent
          dragEnabled
          dragStartPredicate={{ distance: 25 }}
          onDragStart={() => setIsDragging(true)}
          onDragEnd={async (item: any) => {
            const reorderObject = item
              .getGrid()
              .getItems()
              .reduce(
                (acc: Record<string, number>, listItem: any, idx: number) => {
                  if (listItem.getKey()) {
                    acc[listItem.getKey()] = idx;
                  }
                  return acc;
                },
                {}
              );

            if (onReorder) {
              await onReorder(folderId, reorderObject);
            }

            setIsDragging(false);
          }}
          dragAutoScroll={{
            targets: [
              {
                element: scrollRef,
                axis: AutoScroller.AXIS_Y,
              },
            ],
          }}
        >
          {children}
        </MuuriComponent>
      ) : (
        <div className="MediaContainer-no-media">
          {strings.NO_ENGAGE_MEDIA_CONTAINER(title)}
        </div>
      )}
    </div>
  );
};

export default MediaContainer;
